(() => {
  if (document.documentElement.dataset.avgarAccessoryReveal) return;
  document.documentElement.dataset.avgarAccessoryReveal = 'ready';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.avgar-accessories__grid';
  let observer;
  let rows = new Map();
  function reveal(cards) {
    cards.forEach(card => {
      card.classList.remove('avgar-reveal-pending');
      card.dataset.avgarRevealed = 'true';
    });
  }
  function initialise() {
    if (observer) observer.disconnect();
    rows = new Map();
    const grids = [...document.querySelectorAll(selector)];
    if (motion.matches || !('IntersectionObserver' in window)) {
      grids.forEach(grid => reveal([...grid.children]));
      return;
    }
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal(rows.get(entry.target) || [entry.target]);
        observer.unobserve(entry.target);
      });
    }, {rootMargin: '0px 0px -40px 0px', threshold: 0});
    grids.forEach(grid => {
      const groups = new Map();
      [...grid.children].forEach(card => {
        const top = card.offsetTop;
        if (!groups.has(top)) groups.set(top, []);
        groups.get(top).push(card);
      });
      groups.forEach(cards => {
        const first = cards[0];
        rows.set(first, cards);
        if (first.getBoundingClientRect().top < innerHeight - 40 || cards.some(card => card.dataset.avgarRevealed)) {
          reveal(cards);
        } else {
          cards.forEach(card => card.classList.add('avgar-reveal-pending'));
          observer.observe(first);
        }
      });
    });
  }
  document.addEventListener('focusin', event => {
    const card = event.target.closest('.avgar-reveal-pending');
    if (!card) return;
    for (const cards of rows.values()) {
      if (cards.includes(card)) reveal(cards);
    }
  });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initialise, 120);
  });
  motion.addEventListener('change', initialise);
  document.addEventListener('shopify:section:load', initialise);
  initialise();
})();
